module.exports = __webpack_public_path__ + "img/sideRed.0bd5a148.png";